import { POPUP_ID } from './popup.constants';

export const initialState = {
  popupData: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POPUP_ID: {
      return {
        ...state,
        popupData: { id: action.popupId, options: action.popupOptions },
      };
    }
    default:
      return state;
  }
};
